import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge 默认只认识 Tailwind 自带的圆角刻度（sm/md/lg/xl/full…）。
 * 本仓库的圆角阶梯是自定义的 `rounded-apple*`，它落不进 rounded 组，于是
 * `cn('rounded-md', 'rounded-apple-sm')` 会把两个类都留下——而产物里
 * `.rounded-md` 排在 `.rounded-apple-sm` 之后，写了也白写。
 *
 * 表现是**静默的**：类名在 DOM 上看得见，圆角却是组件自带的那一档。
 * 注册进 rounded 组之后，`rounded-apple-*` 才能像原生刻度一样顶掉前面的圆角。
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ['apple-sm', 'apple', 'apple-lg', 'apple-xl'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
